import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { AUFTRAG_API } from '@Constants/backendConstants';
import { initialOrderSorting, orderColumns } from '@Constants/TableColumns';
import { useLatestContainerRentOrderIds } from '@Hooks/Orders';
import { useListApi } from '@Hooks/useListApi';
import { useRemoteCacheInvalidation } from '@Hooks/useRemoteCacheInvalidation';
import { type IHasTableModes } from '@Hooks/useTableModes';
import { type ApiOrder, EnumFrontendLayoutSetting } from '@Model';
import { OrdersRepository } from '@Repositories/Auftragsbearbeitung';
import { type ListRequest, type ListRequestWithIds, useTableRefetch } from '@synqo/frontend-component-library';
import { useCallback } from 'react';
import { useClientNavigate } from '../../../../Routing/useClientNavigate';
import { type ContainerRentTableModes } from './containerRentTableModes';
import { useContainerStockTableModeToolbar } from './useContainerStockTableModeToolbar';

/** The orders the user's last rent run created. */
// @ai-generated 2026-10-21T10:12:41+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function FrameListLatestContainerRentOrders(tableModeProps: IHasTableModes<ContainerRentTableModes>) {
    const navigate = useClientNavigate();
    const { refetchRef, refetchTable } = useTableRefetch();
    useRemoteCacheInvalidation('orders', refetchTable);

    const { loadBatch } = useListApi(OrdersRepository, AUFTRAG_API, ['Customer', 'Site']);
    const { latestOrderIds } = useLatestContainerRentOrderIds();

    const tableLoader = useCallback(
        (request: ListRequest) => {
            const requestWithIds: ListRequestWithIds = { ...request, include_ids: latestOrderIds, exclude_ids: [] };

            return loadBatch(requestWithIds);
        },
        [loadBatch, latestOrderIds],
    );

    const toolbarElements = useContainerStockTableModeToolbar(tableModeProps);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiOrder>
            layoutSettingsContext={EnumFrontendLayoutSetting.OrdersTableLayout}
            name="LatestContainerRentOrderList"
            columns={orderColumns}
            loader={tableLoader}
            refetchRef={refetchRef}
            canCreate={false}
            useOnClickNavigation
            fullSize
            initialSorting={initialOrderSorting}
            onSelect={(order) => {
                navigate(`/orders/${order.id}`);
                return true;
            }}
            toolbarElements={toolbarElements}
        />
    );
}
